import { createApp } from '@backstage/frontend-defaults';
import { appFeatures } from './features';

// Fix for GitHub Copilot plugin dropdown styling issues
import './components/copilot/CopilotDropdownFix.css';

// Static baseline styles — replaces CssBaseline's emotion GlobalStyles which
// fails to inject in production (emotion Global doesn't create its style tag)
import './themes/ThemeBaseline.css';

const app = createApp({ features: appFeatures });

export default app.createRoot();
